import type { ReactNode } from "react";
import { cn } from "@bcc/lib/utils";

interface DataTableEmptyCellProps {
  children?: ReactNode;
  className?: string;
  "data-testid"?: string;
}

export const DataTableEmptyCell = ({ children, className, "data-testid": testId }: DataTableEmptyCellProps) => (
  <span className={cn("text-muted-foreground empty:before:content-['\u2014']", className)} data-testid={testId}>
    {children}
  </span>
);
